import Notification from 'components/Notification';
import { Img } from 'components/shared';
import * as React from 'react';
export default {
  Notification,
  Img,
  React
};